module.exports = __webpack_public_path__ + "static/media/loading_logo.ccaadb87.svg";